<script>
  import { notEmpty, isValidEmail } from '../helpers/form-validation.js'
  import { link, replace, push } from 'svelte-spa-router'
  import { onMount } from 'svelte'
  import AuthContainer from './AuthContainer.svelte'
  import TextInput from '../components/TextInput.svelte'
  import Button from '../components/Button.svelte'
  import { snackBarStore, userStore, tenantStore } from '../state/store'
  import { getTenantData } from '../state/actions'
  import { t } from '../i18n/i18n'
  import { request } from '../helpers/api'

  const jwtDecode = require('jwt-decode')

  let email = ''
  let password = ''

  $: passwordValid = notEmpty(password)
  $: emailValid = isValidEmail(email)
  $: formValid = passwordValid && emailValid

  onMount(() => userStore.set({}))

  const submitForm = async () => {
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        body: JSON.stringify({
          email,
          password
        })
      })
      const { token } = await response.json()
      if (!response.ok) throw new Error($t.incorrect_credentials)
      sessionStorage.setItem('token', token)
      const { user } = jwtDecode(token)
      userStore.set(user)

      if (user.trial_start && user.trial_end && user.role === 'admin') {
        snackBarStore.set({
          message: `${Math.floor(($userStore.trial_end - Math.floor(Date.now() / 1000)) / 86400)} day(s) left in your trial`,
          type: 'info',
          selfDestruct: true
        })
      }

      if (user.status !== 'active' && user.status !== 'trialing' && user.role === 'admin') {
        push('/settings/')
        return
      }

      if (user.status !== 'active' && user.status !== 'trialing' && user.role !== 'admin') {
        snackBarStore.set({ message: $t.subscription_inactive, type: 'error', selfDestruct: true })
        return
      }

      if (user.role !== 'admin') {
        push('/locations/')
        return
      } else {
        getTenantData()
        if ($tenantStore.is_trialing && user.status === 'active') {
          await request({
            url: '/api/tenants',
            method: 'PUT',
            body: JSON.stringify({
              tenant_id: $tenantStore._id
            })
          })
        }
        push('/clients/')
        return
      }
    } catch (error) {
      snackBarStore.set({ message: $t.incorrect_credentials, type: 'error', selfDestruct: true })
    }
  }

</script>

<style>
  form {
    margin-bottom: 2rem;
  }

  p {
    font-size: 1.6rem;
    margin-top: 2.8rem;
  }
</style>
  
<AuthContainer>
  <h1>{$t['Sign In']}</h1>
  <form on:submit|preventDefault={submitForm}>
    <TextInput
      id='email'
      label='{$t.email}'
      valid={emailValid}
      validityMessage='{$t.valid_email}'
      type='email'
      value={email}
      on:input={event => (email = event.target.value)} />
    <TextInput
      id='password'
      label='{$t.password}'
      type='password'
      toggleVisible=true
      valid={passwordValid}
      validityMessage='{$t.valid_password_message}'
      value={password}
      on:input={event => (password = event.target.value)} />
    <Button type='submit' size='full' disabled={!formValid}>
      {$t['Sign In']}
    </Button>
  </form>
  <p class='g-center'>{$t.dont_have_account}
    <a href="/getting-started/" use:link>{$t['Register Today']}</a>
  </p>
  <p class='g-center'>{$t.trouble_signing_in}
    <a href="/password-reset/" use:link>{$t.reset_password}</a>
  </p>
</AuthContainer>
